<div class="container">
    <h1 class="mt-5 text-center">Login</h1>
    <hr>
    <app-form-auth [action]="'login'"></app-form-auth>
</div>